<template>
  <div class="page-container">
    <div class="page-header">
      <h2>个人中心</h2>
    </div>
    <el-card shadow="never" class="profile-card">
      <el-form label-width="100px" size="small" style="max-width:520px">
        <el-form-item label="姓名">
          <span>{{ user.xm }}</span>
        </el-form-item>
        <el-form-item label="登录名">
          <span>{{ user.dlh }}</span>
        </el-form-item>
        <el-form-item label="手机">
          <el-input v-model="form.sjh" />
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input v-model="form.yx" />
        </el-form-item>
        <el-form-item label="电子签名">
          <div class="sign-block">
            <div v-if="previewUrl" class="sign-preview">
              <img :src="previewUrl" alt="签名预览" />
            </div>
            <div v-else class="sign-empty">尚未上传签名</div>
            <div class="sign-actions">
              <el-upload
                :show-file-list="false"
                accept="image/png,image/jpeg,image/gif,image/webp"
                :http-request="uploadSign"
              >
                <el-button size="small" type="primary" :loading="uploading">上传签名图</el-button>
              </el-upload>
              <p class="sign-tip">建议 PNG 透明底，宽 400px 以内</p>
            </div>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="saving" @click="saveProfile">保存资料</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import api from '@/utils/api'
import { getCurrentUser, setCurrentUser } from '@/utils/user'

export default {
  data() {
    return {
      user: {},
      form: { sjh: '', yx: '' },
      uploading: false,
      saving: false
    }
  },
  computed: {
    previewUrl() {
      const p = this.user.qz_img
      if (!p) return ''
      if (/^https?:\/\//.test(p)) return p
      return p.startsWith('/') ? p : '/' + p
    }
  },
  mounted() {
    this.loadMe()
  },
  methods: {
    async loadMe() {
      this.user = getCurrentUser()
      this.form.sjh = this.user.sjh || ''
      this.form.yx = this.user.yx || ''
      try {
        const res = await api.get('yn_me')
        if (res.data && res.data.id) {
          this.user = res.data
          setCurrentUser(res.data)
          this.form.sjh = res.data.sjh || ''
          this.form.yx = res.data.yx || ''
        }
      } catch (e) {
        /* 使用 session 缓存 */
      }
    },
    async uploadSign({ file }) {
      this.uploading = true
      try {
        const res = await api.upload('yn_yh_qz_upload', file)
        const data = res.data
        if (typeof data === 'string' && data.startsWith('22|')) {
          this.$message.error(data.slice(3) || '上传失败')
          return
        }
        if (data && data.path) {
          this.user = { ...this.user, qz_img: data.path }
          setCurrentUser(this.user)
          this.$message.success('签名上传成功')
        } else {
          this.$message.error('上传失败，请重试')
        }
      } catch (e) {
        this.$message.error(e.message || '上传失败')
      } finally {
        this.uploading = false
      }
    },
    async saveProfile() {
      if (!this.user.id) return
      this.saving = true
      try {
        const res = await api.post('yn_yh_save', {
          id: this.user.id,
          dlh: this.user.dlh,
          xm: this.user.xm,
          sjh: this.form.sjh,
          yx: this.form.yx,
          qz_img: this.user.qz_img || '',
          zt: this.user.zt || 1
        })
        if (String(res.data) !== '11') {
          this.$message.error(typeof res.data === 'string' ? res.data.replace(/^22\|/, '') : '保存失败')
          return
        }
        const updated = { ...this.user, sjh: this.form.sjh, yx: this.form.yx }
        setCurrentUser(updated)
        this.user = updated
        this.$message.success('已保存')
      } catch (e) {
        this.$message.error(e.message || '保存失败')
      } finally {
        this.saving = false
      }
    }
  }
}
</script>

<style scoped>
.profile-card { max-width: 640px; }
.sign-block { display: flex; flex-direction: column; gap: 12px; }
.sign-preview {
  border: 1px solid #dcdfe6;
  padding: 8px 12px;
  background: #fafafa;
  min-height: 60px;
  display: flex;
  align-items: center;
}
.sign-preview img {
  max-height: 56px;
  max-width: 280px;
  object-fit: contain;
}
.sign-empty {
  color: #909399;
  font-size: 13px;
  padding: 16px 0;
}
.sign-tip {
  margin: 8px 0 0;
  font-size: 12px;
  color: #909399;
}
</style>
